import { Component } from '@angular/core';
import { AuthHelperService } from '@iws-ux/auth';
import { userRequiredPermissionName } from '../../app.roles';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

    public userAllowedAccess: boolean = false;

    constructor(private authHelper: AuthHelperService) {

        this.userAllowedAccess = authHelper.userHasPermission([userRequiredPermissionName]);
    }
}
